import React from 'react';
import { Link } from 'react-router-dom';
import IconArrow from 'src/assets/images/icons/arrow-left_ico.svg';
import { SettingsMainProps } from './types';

export const SettingsMain: React.FC<SettingsMainProps> = ({ title, subtitle, backPath, topActions, children }) => (
  <div className='flex-1 relative h-full flex flex-col'>
    <div className='flex items-center gap-20 px-16 xl:px-24 py-20 xl:py-24'>
      {backPath && (
        <Link
          to={backPath}
          className='w-40 h-40 rounded-full bg-neutral-10 border border-neutral-20 transition-all duration-300 hover:border-neutral-40 flex items-center justify-center'
        >
          <img src={IconArrow} alt='Back' />
        </Link>
      )}
      <div>
        <h2 className='text-20 xl:text-2xl font-semibold text-neutral-90'>{title}</h2>
        {subtitle && <p className='mt-2 text-neutral-60 text-12 xl:text-14'>{subtitle}</p>}
      </div>
      {topActions && <div className='ml-auto flex items-center gap-10 xl:gap-12'>{topActions}</div>}
    </div>

    {/* Main content */}
    <div className='relative flex-1 flex flex-col min-h-0 pt-12'>{children}</div>
  </div>
);
